import React from "react";
import Breadcrumb from "../ProfileCommon/Breadcrumb";
import NewHeader from "../../Home/NewHeader";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import images from "../../../images";
import PowerUpCard from "../ProfileCommon/PowerUpCard";

const powerUps = [
  {
    icon: images.SubPowerUpImage,
    title: "Ralligator",
    howToEarn: "You were specially invited :)",
    perk: "Invite up to 10 friends! If they sign up and finish their first quest, you’ll snag a bonus of 100 Rally coins for each friend.",
    referralCode: "J205",
    isCompleted: true,
  },
  {
    icon: images.RookieRush,
    title: "Rookie Rush",
    howToEarn: "Complete your first quest",
    perk: "Complete your 1st quest and get 1.5x XP boost for next 2 days.",
    isCompleted: true,
  },
  {
    icon: images.RookieRush,
    title: "Rookie Rush",
    howToEarn: "Complete your first quest",
    perk: "Complete your 1st quest and get 1.5x XP boost for next 2 days.",
    isCompleted: false,
  },
];

const PowerUp = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex overflow-y-auto flex-col mx-auto w-full bg-white max-w-[480px]">
      <div className="flex flex-col w-full min-h-[912px]">
        <div className="fixed top-0 left-0 w-full z-50">
          <NewHeader />
        </div>
        <div className="h-7"></div>
        <div className="flex flex-col flex-1 gap-3 py-3.5 px-[30px]  mt-4">
          <Breadcrumb
            breadCrumbTiltle={t("profile.powerUp")}
            onClickBack={() => navigate("/profile")}
            imagesSubTitle={images.RallyPowerUp}
          />

          <p className="text-[#253FF6] font-[Figtree] text-[16px] font-medium not-italic leading-[24px]">
            Power Up your quests with extra rewards <br /> when you hit those
            special milestones!
          </p>

          <div className="flex flex-col gap-6 mt-4">
            {powerUps.map((item, index) => (
              <PowerUpCard
                key={index}
                icon={item.icon}
                title={item.title}
                howToEarn={item.howToEarn}
                perk={item.perk}
                referralCode={item.referralCode}
                isCompleted={item.isCompleted}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PowerUp;
